import qs from 'qs';
import { all, takeLatest, put, call } from 'redux-saga/effects';
import { request } from '../../utils/http';
import {
  SOLUTIONS_REQUEST,
  SOLUTIONS_ME_REQUEST,
  SOLUTIONS_SUCCESS,
  SOLUTIONS_ERROR,
  SOLUTIONS_ME_ERROR,
  SOLUTIONS_ME_SUCCESS,
  SOLUTIONS_LATEST_REQUEST,
  SOLUTIONS_LATEST_SUCCESS,
  SOLUTIONS_LATEST_ERROR,
} from '../reducers/SolutionsReducer';
import { getSimplifiedError } from '../../utils/error';

function getMySolutions(query) {
  const url = query
    ? `/solutions/my/?${qs.stringify(query)}`
    : '/solutions/my/';
  return request.get(url);
}

function* handleGetMySolutions({ query }) {
  try {
    const { data } = yield call(getMySolutions, query);
    yield put({
      type: SOLUTIONS_ME_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: SOLUTIONS_ME_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getLatestSolutions() {
  return request.get(`/solutions/latest/`);
}

function* handleGetLatestSolutions() {
  try {
    const { data } = yield call(getLatestSolutions);
    yield put({
      type: SOLUTIONS_LATEST_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: SOLUTIONS_LATEST_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getSolutions(query) {
  const url = query ? `/solutions/?${qs.stringify(query)}` : '/solutions/';
  return request.get(url);
}

function* handleGetSolutions({ query }) {
  try {
    const { data } = yield call(getSolutions, query);
    yield put({
      type: SOLUTIONS_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: SOLUTIONS_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

export default all([
  takeLatest(SOLUTIONS_REQUEST, handleGetSolutions),
  takeLatest(SOLUTIONS_ME_REQUEST, handleGetMySolutions),
  takeLatest(SOLUTIONS_LATEST_REQUEST, handleGetLatestSolutions),
]);
